import { RequestWithRelations } from '@/models/request';
import { hasPermission, UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  ArticleWithRelationsInStep,
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

export const computeValidationContext = ({
  request,
  article,
  view,
  requestView,
  currentSession,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelationsInStep<'validation'>;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  const isPendingValidationOnBehalfOfClient =
    article.step.config.actOnBehalfOfClient && !article.taskType;

  const canValidateOnBehalfOfClient = hasPermission(currentSession, 'write_client_communication', {
    entityId: request.storeId,
  });

  if (isPendingValidationOnBehalfOfClient && canValidateOnBehalfOfClient) {
    view.services.actions.fields.description.editable = true;
    view.services.actions.fields.brandResponsibility.editable = true;
    view.services.actions.fields.organizationPrice.editable =
      requestView.organizationPrice.editable;
    view.services.actions.fields.organizationPrice.required = true;
    view.services.actions.fields.spareParts.organizationPrice.editable =
      requestView.organizationPrice.editable;
    view.services.actions.fields.spareParts.organizationPrice.required = true;
    view.services.exchange.organizationPrice.editable = requestView.organizationPrice.editable;
    view.services.exchange.organizationPrice.required = true;
    view.services.actions.canRemoveAction = !!article.step.config.actionLevelValidation?.enabled;
    view.defects.fields.brandResponsibility.toggle.editable = true;
  }
};
